import request from '@/utils/request'

const BASIC_AUTHORIZATION = 'Basic dWk6dWk='


export function login(parameter) {
	console.log(parameter);
	return request({
		url: '/auth/admin/pass',
		headers: {
			'Content-Type': 'application/json'
		},
		method: 'post',
		data: parameter
	})
}

export function checkToken(token) {
	return request({
		headers: {
			'Authorization': BASIC_AUTHORIZATION
		},
		url: '/oauth/check_token',
		method: 'post',
		params: {token: token}
	})
}

export function logout() {
	return request({
		url: '/oauth/logout',
		method: 'delete'
	})
}
